export const ASSESSMENT_TOUR_TARGETS = {
  proctoring: "proctoring-joyride",
  currentQuestion: "currentQuestion-joyride",
  questionPanel: "questionPanner-joyride",
  trackTime: "trackTime-joyride",
  submit: "submit-joyride",
}
